module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"受け取る設定に変更しました":"受け取る設定に変更しました","受け取らない設定に変更しました":"受け取らない設定に変更しました"},"en":{"受け取る設定に変更しました":"Changed the settings to receive.","受け取らない設定に変更しました":"Change the setting to not accept them."}}')
  delete Component.options._Ctor
}
